
import Vue from 'vue'
import moment from 'moment'
import Shared from '../../shared.js'

import CompetitionComponent from '../../components/Competitons.component.vue'
import NewSeasonComponent from '../../components/CreateSeason.component.vue'
import { showSnackbar } from '@/globalActions/index.js'

export default Vue.extend({
  name: 'Competitions',
  components: {
    CompetitionComponent,
    NewSeasonComponent
  },
  mixins: [Shared],
  data () {
    return {
      season: false,
      dialog: false,
      expanded: [],
      singleExpand: false,
      dialogData: {
        info: {},
        matches: []
      },
      items: {},
      seasons: Array<any>(),
      selected: { name: '', id: '' } as { name: string; id: string },
      loading: false,
      competitionType: {
        name: ''
      },
      competitionTypeAlert: false,
      syncingFromStore: false
    }
  },
  watch: {
    selected: function (val) {
      if (!val || !val.id) return
      if (this.syncingFromStore) return
      this.$store.dispatch('SeasonModule/setSelectedId', val.id)
      this.changeSeason(val.id)
    },
    '$store.state.SeasonModule.selectedId': function (id: string | null) {
      if (!id) return
      if (this.selected && this.selected.id === id) return
      const match = this.seasons.find((s: any) => s.id === id)
      if (match) {
        this.syncingFromStore = true
        this.selected = match
        this.changeSeason(id)
        this.$nextTick(() => {
          this.syncingFromStore = false
        })
      }
    }
  },
  created () {
    this.$store.dispatch('venues/fetchAndAdd', { clauses: { limit: 0 } })
    this.$store.dispatch('SeasonModule/ensureSelected').then((season: any) => {
      // Block selected watcher before filling items — v-select can emit
      // when :items updates and would otherwise overwrite Vuex selectedId.
      this.syncingFromStore = true
      this.seasons = this.$store.getters['SeasonModule/sortedASC']
      if (season) {
        this.selected = season
        this.changeSeason(season.id)
      }
      this.$nextTick(() => {
        this.syncingFromStore = false
      })
    })
  },
  methods: {
    changeSeason (val: string) {
      this.$store.dispatch('CompetitionTypesModule/fetchAndAdd', { where: [['seasonId', '==', val]] })
        .then(() => {
          this.$store.dispatch('CompetitionTypesModule/filterBySeason', { season: val })
        })
        .catch((error: any) => {
          console.error(error)
        })
    },
    closeDialog () {
      this.dialog = false
      this.dialogData = {
        info: {},
        matches: []
      }
    },
    onTypeCreate (e: any) {
      e.preventDefault()
      if (this.competitionType.name === '') {
        showSnackbar(this.$t('please-enter-name'), { color: 'red' })
        return
      }
      this.competitionTypeAlert = false
      this.loading = true
      this.$store.dispatch('CompetitionTypesModule/set', {
        name: this.competitionType.name,
        seasonId: this.selected.id
      }).then(() => {
        this.competitionType.name = ''
        this.changeSeason(this.selected.id)
      })
    },
    onSeasonCreated (value: { data: any; display: boolean }) {
      this.$store.dispatch('SeasonModule/fetchAndAdd').then(() => {
        this.seasons = this.$store.getters['SeasonModule/sortedASC']
        if (value.data && value.data.id) {
          this.$store.dispatch('SeasonModule/setSelectedId', value.data.id)
          this.selected = value.data
        }
      })
      this.season = value.display
    },
    closeSeasonDialog () {
      this.season = false
    },
    parseDate (date: any) {
      return moment(moment.unix(date.seconds), 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  }
})
